import moment from 'moment';

import {AnalyticsEvent, deprecatedTrackEvent} from './Analytics';

/**
 * Convenience class to encapsulate state for elapsed time for analytics events
 */
export default class ElapsedTimeEventTracker {
  analyticsEvent: AnalyticsEvent;
  startMoment: moment.Moment | null;

  constructor(analyticsEvent: AnalyticsEvent) {
    this.analyticsEvent = analyticsEvent;
    this.startMoment = null;
  }

  startTimer(): void {
    this.startMoment = moment();
  }

  stopTimerAndTrack(): void {
    if (this.startMoment != null) {
      deprecatedTrackEvent(this.analyticsEvent, {millisecondsElapsed: moment().diff(this.startMoment)});
      this.startMoment = null;
    }
  }
}
